import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import DropdownTrigger from '@client/components/inputs/dropdownTrigger/DropdownTrigger';
import { languages } from '@client/shared/utils/languageUtils/languageUtils';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './languageDropdown.scss';

function LanguageDropdown({ triggerClassName, light }) {
  const { i18n } = useTranslation(['landing']);
  const location = useLocation();
  const activeLanguage = i18n.language ?? 'sv';

  const onHandleChangeLanguage = (lng) => {
    window.location = `/${lng}${location.pathname}`;
  };

  return (
    <DropdownTrigger
      shouldTriggerReceiveState={true}
      TriggerElement={
        <RenderTrigger
          activeLanguage={activeLanguage}
          light={light}
          triggerClassName={triggerClassName}
        />
      }
      className={styles.languageDropdownTrigger}
      dropdownClassName={styles.dropdownProp}
      DropdownContent={
        <DropdownContent
          onHandleChangeLanguage={onHandleChangeLanguage}
          activeLanguage={activeLanguage}
        />
      }
    />
  );
}

LanguageDropdown.propTypes = {
  triggerClassName: PropTypes.string,
  i18n: PropTypes.object,
  light: PropTypes.bool,
};

export default LanguageDropdown;

const RenderTrigger = ({
  activeLanguage,
  light,
  triggerClassName,
  isTriggerOpen,
  onClick,
}) => {
  return (
    <button
      className={classNames(styles.triggerContainer, triggerClassName)}
      onClick={onClick}
    >
      <span
        className={classNames(styleHelper.text4, light && styles.lightTheme)}
      >
        {activeLanguage}
      </span>
      <i
        className={classNames(
          styles.triggerIcon,
          isTriggerOpen
            ? styleHelper.iconchevronup
            : styleHelper.iconchevrondown,
          light && styles.lightTheme
        )}
      />
    </button>
  );
};

RenderTrigger.propTypes = {
  activeLanguage: PropTypes.string,
  light: PropTypes.bool,
  triggerClassName: PropTypes.string,
  isTriggerOpen: PropTypes.bool,
  onClick: PropTypes.func,
};

const DropdownContent = ({ onHandleChangeLanguage, activeLanguage }) => {
  function getDropdownOptionClassNames(lng) {
    return classNames({
      [styles.dropdownOption]: true,
      [styles.inactiveOption]: lng !== activeLanguage,
      [styleHelper.text9_inverse]: lng === activeLanguage,
    });
  }

  return (
    <div className={classNames(styles.dropdownContent, styleHelper.text5)}>
      {Object.keys(languages).map((lng) => (
        <div
          key={lng}
          className={getDropdownOptionClassNames(lng)}
          onClick={() => onHandleChangeLanguage(lng)}
        >
          {languages[lng].nativeName}
        </div>
      ))}
    </div>
  );
};

DropdownContent.propTypes = {
  activeLanguage: PropTypes.string,
  onHandleChangeLanguage: PropTypes.func,
};
